import React from 'react'
import styled from 'styled-components'
import PopupCSSTransform from './PopupCSSTransform'

export const PopupWithDepth = styled(PopupCSSTransform)`
  z-index: 5;
`

const Popup = ({ latitude, longitude, children }) => (
  <PopupWithDepth
    tipSize={0}
    anchor="bottom"
    longitude={longitude}
    latitude={latitude}
    dynamicPosition={false}
    closeButton={false}
    closeOnClick={false}
    captureDrag={false}
  >
    {children}
  </PopupWithDepth>
)

export default Popup
